/* eslint-disable react/prop-types */
import React, { Fragment, useContext } from 'react'
import { useQuery } from '@apollo/client'
import { Placeholder } from 'semantic-ui-react'
import StatusProgression from './StatusProgression'
import ReminderSection from './ReminderSection'
import PayButtons from './PayButtons'
import CompleteButton from './CompleteButton'
import MarkAsPaidButton from './MarkAsPaidButton'
import { SingleProjectContext } from '../../../../Context'
import { LOAD_MANAGE_EXPERT_CARD } from '../../../../graphql/job'

const ManageExpertCard = ({ expert, job = {} }) => {
    const { project } = useContext(SingleProjectContext)

    const { data, loading } = useQuery(LOAD_MANAGE_EXPERT_CARD, {
        skip: !job.id,
        variables: { id: job.id },
    })

    if (loading)
        return (
            <Placeholder>
                <Placeholder.Paragraph>
                    <Placeholder.Line />
                </Placeholder.Paragraph>
            </Placeholder>
        )
    if (!data) return <div />

    const renderJobActions = () => {
        if (project.service_type === 'Self-Service') {
            return <MarkAsPaidButton job={data.job} />
        }
        return (
            <Fragment>
                {job.overall_status === 'Completed' && (
                    <PayButtons job={data.job} />
                )}
                {!['Completed', 'Paid'].includes(job.overall_status) && (
                    <CompleteButton
                        expert={expert}
                        project={project}
                        job={data.job}
                    />
                )}
            </Fragment>
        )
    }

    return (
        <Fragment>
            <StatusProgression project={project} job={data.job} />
            <ReminderSection
                expert={expert}
                project={project}
                job={data.job}
            />
            {renderJobActions()}
        </Fragment>
    )
}

export default ManageExpertCard
